import { changePropertyStatusAction } from 'redux/actions/propertiesActions';
import { generateSimpleRequestReducer } from 'redux/utils/requestWithoutData';

export default generateSimpleRequestReducer(changePropertyStatusAction);
